import React, { useState } from 'react';
import { useSelector } from 'react-redux';
// @ts-ignore
import { FontAwesomeIcon } from '@vr/lib';
import styled from 'styled-components';
import { Button } from '../../elements';
import Details from './Details';
import { VRPAT } from '~/config/constants';

interface ICookieConsent {
  showConsent: boolean;
  onAccept: () => void;
  onClose: () => void;
}

interface IContainer {
  show: boolean;
}

const Container = styled.div<IContainer>`
  background-color: ${({ theme }) => theme.colors.secondary};
  bottom: 0;
  display: ${({ show }) => (show ? 'flex' : 'none')};
  flex-direction: column;
  left: 0;
  padding: 25px 20px;
  position: fixed;
  width: 100%;
  z-index: 999;
`;

const Description = styled.p`
  color: ${({ theme, color }) => {
    // @ts-ignore
    return theme.colors[color];
  }};
  margin-bottom: 25px;
`;
const Actions = styled.div`
  display: flex;
  flex-direction: column;

  button {
    max-width: unset !important;
    width: auto;
  }
  button:first-child {
    margin-bottom: 10px;
  }

  @media (min-width: ${({ theme }) => theme.devices.mobile}) {
    flex-direction: row;

    button:first-child {
      margin-bottom: 0;
      margin-right: 10px;
    }
  }
`;
const Close = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  height: 45px;
  justify-content: center;
  position: absolute;
  right: 20px;
  top: -22px;
  width: 45px;
`;
const CloseIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1.4rem;
`;

export default function CookieConsent({
  showConsent,
  onAccept,
  onClose,
}: ICookieConsent): JSX.Element {
  const [showModal, setShowModal] = useState<boolean>(false);
  // @ts-ignore
  const issuer = useSelector(state => state?.issuer);
  const color = issuer?.name === VRPAT ? 'primary' : 'institucionalDark';
  const btnColor = issuer?.name === VRPAT ? 'institutional' : 'secondary';

  function handleAcceptModal() {
    onAccept();
    setShowModal(false);
  }

  return (
    <>
      <Container show={showConsent}>
        <Close data-testid="close-consent" onClick={() => onClose()}>
          <CloseIcon icon="times" />
        </Close>
        <Description color={color}>
          Nós utilizamos cookies para diversas funcionalidades, você concorda
          que a {issuer?.company} use e compartilhe cookies.
        </Description>
        <Actions>
          {/* @ts-ignore */}
          <Button
            ariaLabel="Aceitar termos"
            label="ACEITAR TERMO DE PRIVACIDADE"
            variant="outlined"
            onClick={() => onAccept()}
            size="small"
            color={btnColor}
          />
          {/* @ts-ignore */}
          <Button
            ariaLabel="Mostrar mais"
            label="MOSTRAR MAIS"
            variant="outlined"
            onClick={() => setShowModal(true)}
            size="small"
            color={btnColor}
          />
        </Actions>
      </Container>
      <Details
        handleAccept={handleAcceptModal}
        closeModal={setShowModal}
        showModal={showModal}
        issuer={issuer}
      />
    </>
  );
}
